import { render, staticRenderFns } from "./ClientProjectRow.vue?vue&type=template&id=41f6b206&scoped=true&"
import script from "./ClientProjectRow.vue?vue&type=script&lang=js&"
export * from "./ClientProjectRow.vue?vue&type=script&lang=js&"
import style0 from "./ClientProjectRow.vue?vue&type=style&index=0&id=41f6b206&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f6b206",
  null
  
)

export default component.exports